export default {
  assign_to_myself: 'призначити на себе',
  reassign: 'Призначити на користувача',
  modal: {
    title: 'Перепризначити чат з {цифра}',
    description: 'Оберіть користувача, щоб назначити на діалог',
    other_options: 'інші опції',
    unassigned_title: 'Не назначено',
    unassigned_description: 'Будь-який інший користувач може продовжити чат',
  },
  with: {
    title: 'з', 
    me: 'Me',
  },
}
